type GetPlanPricesReturn = {
    salePrice: number | undefined;
    monthlyEquivalentSalePrice: number | undefined;
};

const getPlanPrices = ({
    subscriptionPrice,
    monthlyEquivalentPrice,
    discountPercentage = 0,
}: {
    subscriptionPrice?: number;
    monthlyEquivalentPrice?: number;
    discountPercentage?: number;
}): GetPlanPricesReturn => {
    const salePrice =
        discountPercentage && subscriptionPrice
            ? subscriptionPrice * ((100 - discountPercentage) / 100)
            : undefined;

    const monthlyEquivalentSalePrice =
        discountPercentage && monthlyEquivalentPrice
            ? monthlyEquivalentPrice * ((100 - discountPercentage) / 100)
            : undefined;

    return {
        salePrice,
        monthlyEquivalentSalePrice,
    };
};

export default getPlanPrices;
